// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scrollbar::-webkit-scrollbar {
  width: 4px; }

.scrollbar::-webkit-scrollbar-track-piece {
  background: #922b86;
  border-radius: 12px;
  margin-block: 27px; }

.scrollbar::-webkit-scrollbar-thumb {
  background: #ba83b8;
  border-radius: 12px; }
`, "",{"version":3,"sources":["webpack://./src/components/Search/scrollbar.scss"],"names":[],"mappings":"AAAA;EACE,UAAU,EAAA;;AAGZ;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,mBAAmB;EACnB,mBAAmB,EAAA","sourcesContent":[".scrollbar::-webkit-scrollbar {\n  width: 4px;\n}\n\n.scrollbar::-webkit-scrollbar-track-piece {\n  background: #922b86;\n  border-radius: 12px;\n  margin-block: 27px;\n}\n\n.scrollbar::-webkit-scrollbar-thumb {\n  background: #ba83b8;\n  border-radius: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
